import React, { useState, useEffect, useRef } from 'react';
import './GallerySection.css';

const GallerySection = () => {
  // Sample gallery images
  const galleryImages = [
    { id: 1, src: '/images/1.jpeg', alt: 'Gallery Image 1' },
    { id: 2, src: '/images/2.jpeg', alt: 'Gallery Image 2' },
    { id: 3, src: '/images/3.jpeg', alt: 'Gallery Image 3' },
    { id: 4, src: '/images/4.jpeg', alt: 'Gallery Image 4' },
    { id: 5, src: '/images/5.jpeg', alt: 'Gallery Image 5' },
    { id: 6, src: '/images/6.jpeg', alt: 'Gallery Image 6' },
  ];

  const sliderRef = useRef(null);
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const slider = sliderRef.current;
    if (!slider) return;

    const interval = setInterval(() => {
      setCurrentSlide(prevSlide => {
        const nextSlide = (prevSlide + 1) % galleryImages.length;
        // Scroll to the next slide
        const slideWidth = slider.querySelector('.gallery-slide').offsetWidth;
        slider.scrollTo({
          left: nextSlide * (slideWidth + 16), // 16px is the gap
          behavior: 'smooth'
        });
        return nextSlide;
      });
    }, 3000); // Change slide every 3 seconds

    return () => clearInterval(interval);
  }, [galleryImages.length]);

  return (
    <section className="gallery-section">
      <div className="gallery-container">
        <h2 className="gallery-title">Gallery</h2>
        <p className="gallery-subtitle">Take a look at our facilities and ambiance</p>
        
        <div className="gallery-grid">
          {galleryImages.map(image => (
            <div key={image.id} className="gallery-item">
              <img src={image.src} alt={image.alt} className="gallery-image" />
              <div className="gallery-overlay">
                <span className="gallery-caption">{image.alt}</span>
              </div>
            </div>
          ))}
        </div>
        
        {/* Mobile slider view */}
        <div className="gallery-slider" ref={sliderRef}>
          {galleryImages.map(image => (
            <div key={image.id} className="gallery-slide">
              <img src={image.src} alt={image.alt} className="gallery-image" />
              <div className="gallery-overlay">
                <span className="gallery-caption">{image.alt}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default GallerySection;
